import httpClientePublicoCore from '../../Servicios/httpClientePublicoCore';

// Se encacarga de listar Generos
export const listarGnlGender = (idCompania, idUser) => {
    return new Promise((resolve, reject) => {
        httpClientePublicoCore.post('/ClientProps/Generos/', {
            CompanyId: idCompania, UserId: idUser
        }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se encacarga de listar Estados Civil
export const listarGnlCivilStatus = (idCompania, idUser) => {
    return new Promise((resolve, reject) => {
        httpClientePublicoCore.post('/ClientProps/EstadoCivil/', {
            CompanyId: idCompania, UserId: idUser
        }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se encacarga de listar Tipos de identificacion
export const listarGnlIdeType = (idCompania, idUser) => {
    return new Promise((resolve, reject) => {
        httpClientePublicoCore.post('/ClientProps/IdeTypes/', {
            CompanyId: idCompania, UserId: idUser
        }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se encacarga de obtener el Tipo de Cifs del cliente
export const obtenerIdTipoCIF = (tipo) => {
    return new Promise((resolve, reject) => {
        httpClientePublicoCore.post('/ClientProps/BuscarIdTipoCIF/', { Tipo: tipo }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se encacarga de obtener el listado de campor requeridos
export const obtenerCamposRequeridos = (companyId, languajeCode, cifType, customerId) => {
    return new Promise((resolve, reject) => {
        httpClientePublicoCore.post('/ClientProps/CamposRequeridos/', { CompanyId: companyId, LanguajeCode: languajeCode, CIFType: cifType, CustomerId: customerId }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

export default listarGnlGender